"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var bi_logger_1 = require("../../bi-logger");
var BaseWidgetController_1 = require("../BaseWidgetController");
var proxyPolyfill = require('proxy-polyfill/src/proxy');
var BiLoggerController = /** @class */ (function (_super) {
    tslib_1.__extends(BiLoggerController, _super);
    function BiLoggerController(controllerConfig) {
        var _this = _super.call(this, controllerConfig) || this;
        _this.pageReady = function ($w, wixAPI) {
            _this.controllerConfig.setProps({ biLogger: _this.getBiLogger() });
            return Promise.resolve();
        };
        return _this;
    }
    BiLoggerController.prototype.getBiLogger = function () {
        var _a = this.controllerConfig, wixCodeApi = _a.wixCodeApi, platformAPIs = _a.platformAPIs;
        var biLogger = bi_logger_1.getBiLogger({
            biLoggerFactory: platformAPIs.biLoggerFactory(),
            biParams: platformAPIs.bi,
            viewMode: wixCodeApi.window.viewMode,
        });
        var handler = {
            get: function (obj, prop) {
                var biLoggerMethod = biLogger[prop];
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return biLoggerMethod
                        .apply(biLogger, args)
                        .then(function () {
                        if (typeof window !== 'undefined' &&
                            window.location.search.includes('debug')) {
                            console.log("BI Method: " + prop + " called with", args);
                        }
                    })
                        .catch(function (e) {
                        console.log("BI Method: " + prop + " FAILED");
                    });
                };
            },
        };
        var loggerPrototype = Object.getPrototypeOf(biLogger);
        // this crazy JS exercise is because of prototype is not serializable for worker
        try {
            return new Proxy(loggerPrototype, handler);
        }
        catch (e) {
            // IE case
            var ProxyPolyfill = proxyPolyfill();
            return new ProxyPolyfill(loggerPrototype, handler);
        }
    };
    return BiLoggerController;
}(BaseWidgetController_1.BaseWidgetController));
exports.BiLoggerController = BiLoggerController;
//# sourceMappingURL=BiLoggerController.js.map